import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config.js';

const IDLE = { path: null, status: 'idle', data: null, error: null };

/** GET on /api/admin/visit-topics{path}: { status: 'idle' | 'loading' | 'ready' | 'error', data, error }; a null path makes no request and a response for an older path is dropped. */
export const useVisitTopicsData = (fetchWithAuth, path) => {
  const [result, setResult] = useState(IDLE);

  useEffect(() => {
    if (!path) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const response = await fetchWithAuth(`${API_BASE_URL}/api/admin/visit-topics${path}`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        if (!cancelled) setResult({ path, status: 'ready', data, error: null });
      } catch (error) {
        console.error(`Error fetching the visit topics ${path}:`, error);
        if (!cancelled) setResult({ path, status: 'error', data: null, error });
      }
    })();
    return () => { cancelled = true; };
  }, [fetchWithAuth, path]);

  if (!path) return IDLE;
  return result.path === path ? result : { path, status: 'loading', data: null, error: null };
};

export default useVisitTopicsData;
